import React from "react";

const TemarioDiplomaturaSkincare = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Introducción al cuidado de la piel"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Fundamentos de anatomía y fisiología de la piel"}</span></li>
                <li><span className="fw-light">{"Identificación de tipos de piel y sus características"}</span></li>
                <li><span className="fw-light">{"Introducción a ingredientes básicos en productos de Skincare"}</span></li>
            </ul>
            <br /><br />
            <b>{"Problemas comunes en la piel"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Acné: causas y tratamientos"}</span></li>
                <li><span className="fw-light">{"Pigmentación y melasmas"}</span></li>
                <li><span className="fw-light">{"Envejecimiento cutáneo y prevención"}</span></li>
            </ul>
            <br /><br />
            <b>{"Ingredientes clave en skincare"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Acidos (AH, glicolico, salicílico, etc)"}</span></li>
                <li><span className="fw-light">{"Antioxidantes (vit C, E, etc)"}</span></li>
                <li><span className="fw-light">{"Hidratantes y emolientes"}</span></li>
            </ul>
            <br /><br />
            <b>{"Rutina de skincare diaria"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Pasos esenciales en una rutina diaria"}</span></li>
                <li><span className="fw-light">{"Selección de productos según tipo de piel"}</span></li>
                <li><span className="fw-light">{"Importancia del uso de protector solar y su aplicación adecuada"}</span></li>
            </ul>
            <br /><br />
            <b>{"Skincare avanzado"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Exfoliación y su importancial"}</span></li>
                <li><span className="fw-light">{"Mascaras faciales y tratamientos específicos"}</span></li>
                <li><span className="fw-light">{"Dispositivos y herramientas de Skincare"}</span></li>
            </ul>
            <br /><br />
            <b>{"Nutrición y estilo de vida para una piel saludable"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Impacto de la dieta en la salud de la piel"}</span></li>
                <li><span className="fw-light">{"Estrés y su influencia en la piel"}</span></li>
                <li><span className="fw-light">{"Importancia del descansa y el ejercicio"}</span></li>
                <li><span className="fw-light">{"Aspectos psicosociales"}</span></li>
            </ul>
            <br /><br />
            <b>{"Cuidado corporal"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Hidratación corporal y técnicas de exfoliación"}</span></li>
                <li><span className="fw-light">{"Cuidado de manos, pies y áreas específicas"}</span></li>
                <li><span className="fw-light">{"Prevención, tratamiento de estrías y celulitis"}</span></li>
            </ul>
            <br /><br />
            <b>{"Skincare ético y sostenible"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Ingredientes naturales y orgánicos"}</span></li>
                <li><span className="fw-light">{"Ética en pruebas de productos y desarrollo sostenible"}</span></li>
                <li><span className="fw-light">{"Marcas responsables y su impacto ambiental"}</span></li>
            </ul>
            <br /><br />
            <b>{"Práctica y evaluación final"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Demostración de una rutina de skincare personalizada"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaSkincare;
